// This is special case of a parameter where we don't have ranges but a single range where result will always be normal / grey
const antiMullerHormon = {
  parameters: [
    {
      name: 'antiMullerHormon',
      id: 'antiMullerHormon',
      displayName: 'Anti-Müllerian Hormone',
      labReportName: 'Anti-Müllerian Hormone',
      validFrom: '2025/02/18 1:00',
      validThrough: null,
      interpretationsSupported: ['normal'],
      ranges: [
        {
          color: '#6f6b72',
          description: 'antiMullerHormon-normal',
          lowerLimit: 0,
          lowerLimitOperator: '>=',
          upperLimit: 1000,
          upperLimitOperator: '<',
          unit: 'pmol/L',
          interpretation: 'normal',
          displayInterpretation: 'Normal',
        },
      ],
    },
  ],
};

export default antiMullerHormon;
